import { Client, Experiment, StubExperimentClient } from '@amplitude/experiment-js-client';

const stubExperiment = new StubExperimentClient();
let experiment: Client | null = null;

export const getExperiment = (canUseAmplitude = false): Client => {
  if (
    !canUseAmplitude ||
    typeof window === 'undefined' ||
    process.env.NEXT_PUBLIC_AMPLITUDE_DISABLED === 'true' ||
    !process.env.NEXT_PUBLIC_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY
  ) {
    return stubExperiment;
  }

  if (!experiment) {
    experiment = Experiment.initializeWithAmplitudeAnalytics(
      process.env.NEXT_PUBLIC_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY
    );
  }

  return experiment;
};

export const clearAmplitudeExperiment = () => {
  if (!experiment) {
    return;
  }

  try {
    experiment.clear();
  } catch {
    // Experiment storage may be unavailable in restricted browser contexts.
  }

  experiment = null;
};
